// Nova Pro Theme - Global JavaScript

(function() {
  'use strict';

  // Shopify Cart API
  window.theme = window.theme || {};

  theme.cart = {
    add: function(id, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity || 1
        })
      }).then(response => response.json());
    },
    
    update: function(updates) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      }).then(response => response.json());
    },
    
    get: function() {
      return fetch('/cart.js').then(response => response.json());
    }
  };

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      document.body.classList.toggle('menu-open');
    });
  }

 

  console.log('Nova Pro Theme loaded');
})();
